// extracted by mini-css-extract-plugin
module.exports = {"root":"GoalItem_root__2bUtP","editable":"GoalItem_editable__2EDiG","rightColumn":"GoalItem_rightColumn__tfYij","heading":"GoalItem_heading__2achC"};